import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.529.862a.667.667 0 0 1 .942 0l4.667 4.666a.67.67 0 0 1 .162.264.644.644 0 0 1 .026.109.67.67 0 0 1 .007.099l-.002-.058a.724.724 0 0 1 .002.036V6a.674.674 0 0 1-.083.323.69.69 0 0 1-.047.074.672.672 0 0 1-.065.074l.054-.06-.005.006-.049.054-4.667 4.667a.667.667 0 1 1-.942-.943l3.528-3.529H1.333a.667.667 0 0 1-.662-.589L.667 6a.667.667 0 0 1 .666-.667h7.724L5.529 1.805a.667.667 0 0 1-.056-.88L5.53.862Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }